import React, { useState, useEffect } from 'react';
import './CircleParticles.css';
import Particles from './Particles';

// Stable identity: an inline array literal would re-trigger the particle
// init effect (and re-randomize star positions) on every re-render.
const PARTICLE_COLORS = ['#ffffff'];

// The astronaut's head: rendered inside the Raiinet tile (the body),
// so it stays attached to it at every size and scroll position.
const CircleParticles = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  // Handle image loading
  useEffect(() => {
    const img = new Image();
    img.src = '/images/circle.png';
    img.onload = () => setIsLoaded(true);
  }, []);

  return (
    <div className={`circle-container ${isLoaded ? 'loaded' : ''}`}>
      <img
        src="/images/circle.png"
        alt="Metallic Circle"
        className="metallic-circle"
      />
      <div className="particles-wrapper">
        <Particles
          particleColors={PARTICLE_COLORS}
          particleCount={600}
          particleSpread={0.35}
          speed={0.01}
          particleBaseSize={6}
          moveParticlesOnHover={true}
          alphaParticles={false}
          disableRotation={false}
          cameraDistance={1.5}
          particleHoverFactor={0.1}
          sizeRandomness={0.1}
          className="centered-particles"
        />
      </div>
    </div>
  );
};

export default CircleParticles;
